import { endpoints } from './endpoints';
import type { Environment } from 'client-site-chrome-ui/environment';

interface BasketBody {
  body: {
    query: string;
    variables?: Record<string, string>;
  };
  headers?: Record<string, string>;
}

interface BasketMergeBody {
  body: {
    query: string;
    variables?: Record<string, string>;
  };
  headers?: Record<string, string>;
}

interface BasketItemCountResponse {
  data: {
    basket: {
      itemsCount: number;
    };
  };
}

interface BasketMergeResponse {
  data: {
    mergeBasket: {
      success: boolean;
    };
  };
}

const apiName = 'basket-api';

const ITEM_COUNT_QUERY = '{ basket { itemsCount } }';
const MERGE_BASKET_MUTATION =
  'mutation($anonymousBasketId: ID!) { mergeBasket(identityId: $anonymousBasketId) { success } }';

const addBasketEndpoint = (env: Environment) => {
  window.Amplify.Configure.API.REST.addEndpoint({ name: apiName, endpoint: endpoints[env].basket });
};

export const getBasketItemCount = async (env: Environment, idToken?: string) => {
  try {
    addBasketEndpoint(env);
    const {
      data: {
        basket: { itemsCount },
      },
    } = await window.Amplify.default.API.post<BasketBody, BasketItemCountResponse>(
      apiName,
      '/graphql',
      {
        headers: {
          ...(idToken && {
            'x-id-token': idToken,
          }),
        },
        body: {
          query: ITEM_COUNT_QUERY,
        },
      },
    );

    return itemsCount;
  } catch {
    return null;
  }
};

export const mergeBasket = async (
  env: Environment,
  anonymousBasketId: string,
  idToken?: string,
) => {
  try {
    addBasketEndpoint(env);
    const {
      data: {
        mergeBasket: { success },
      },
    } = await window.Amplify.default.API.post<BasketMergeBody, BasketMergeResponse>(
      apiName,
      '/graphql',
      {
        headers: {
          ...(idToken && {
            'x-id-token': idToken,
          }),
        },
        body: {
          query: MERGE_BASKET_MUTATION,
          variables: { anonymousBasketId },
        },
      },
    );
    return success;
  } catch {
    return false;
  }
};
